import { createElement, useEffect } from 'react';

import { componentWithFG } from '@atlaskit/platform-feature-flags-react/component-with-fg';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import UFOSuspense from '@atlaskit/react-ufo/suspense';
import UFOSegment from '@atlaskit/react-ufo/ufo-segment';

import { type Config, type ModalErrorFallbackProps, type PlaceholderComponentProps } from './types';

function SuspensePlaceholder({ children, fallback, name }: PlaceholderComponentProps) {
	return createElement(UFOSuspense, { children, fallback, interactionName: name });
}

const GlobalModalErrorFallback = ({ closeModal, fallback }: ModalErrorFallbackProps) => {
	const hasFallback = fallback != null;

	useEffect(() => {
		if (!hasFallback) {
			closeModal();
		}
	}, [closeModal, hasFallback]);

	return fallback ?? null;
};

export const defaultEntryPointConfig: Config = {
	PlaceholderComponent: componentWithFG('platform-dst-top-layer', SuspensePlaceholder, Placeholder),
	UFOSegmentComponent: UFOSegment,
	GlobalModalErrorFallback,
};
